import React, { TextareaHTMLAttributes } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { GenericInput } from './GenericInput';
import { Theme } from '@app/theme';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  containerClass?: string;
  value?: any;
  name?: string;
  error?: string;
  noMargin?: boolean;
  preview?: boolean;
  secondaryLabel?: string;
  rightAction?: React.ReactNode;
}

const useStyles = createUseStyles((theme: Theme) => ({
  input: {
    resize: 'vertical',
    padding: `13px ${theme.marginBase * 2}px`,
    height: 'auto',
  },
}));

export const TextArea = React.forwardRef((props: Props, ref) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });

  return (
    <GenericInput
      component="textarea"
      rows={3}
      className={classes.input}
      ref={ref}
      {...props}
    />
  );
});
